export default theme => ({
	wrapperPoi: {
		display: "flex",
		flexDirection: "row"
	},

	header: {
		width: "100vw"
	},
	main: {
		width: "75vw",
		height: "100%"
	},
	sidebar: {
		width: "25vw",
		height: "100%"
	},
	poiGallery: {
		background: "#333"
	},
	mainWrapper: {
		width: "80vw"
	},
	appBar: {
		background: "#fff",
		// borderTop: `1px solid ${theme.palette.primary.main}`,
		"& > div": {
			display: "flex"
		}
	},
	tabs: {
		border: 0
	},
	tab: {
		overflow: "hidden !important"
	},
	iframe: {
		width: "100%",
		overflow: "hidden"
	},
	scrollDown: {
		display: "none",
		position: "fixed",
		zIndex: 999,
		bottom: 0,
		right: "17px",
		"& svg": {
			fill: "#fff",
			width: "2em",
			height: "2em"
		}
	},
	[theme.breakpoints.down("sm")]: {
		wrapperPoi: {
			display: "flex",
			flexDirection: "column-reverse"
		},
		mainWrapper: {
			width: "100vw"
		},
		header: {
			width: "100vw"
		},
		main: {
			width: "100vw",
			height: "auto"
		},
		sidebar: {
			width: "100vw",
			height: "auto"
		},
		iframe: {
			width: "100vw"
		},
		scrollDown: {
			display: "block"
		}
	}
});
